// Libraries
import { useUserStore } from '@/lib/store/user'
import { AuthStep } from '../enums'
const agreementVersion = import.meta.env.VITE_CURRENT_AGREEMENT


// Views
const ViewAuth = () => import(/* webpackChunkName: "auth" */ '@/views/Auth.vue')
const ViewMain = () => import(/* webpackChunkName: "main" */ '@/views/Main.vue')
const ViewPublic = () => import(/* webpackChunkName: "public" */ '@/views/Public.vue')

// Partials
const PartialCalculator = () => import(/* webpackChunkName: "main" */ '@/views/partials/Calculator.vue')
const PartialMe = () => import(/* webpackChunkName: "me" */ '@/views/partials/Me.vue')
const PartialAccount = () => import(/* webpackChunkName: "me" */ '@/views/partials/Account.vue')
const PartialCheckout = () => import(/* webpackChunkName: "checkout" */ '@/views/partials/Checkout.vue')
const PartialInterstitial = () => import(/* webpackChunkName: "me" */ '@/views/partials/Interstitial.vue')

const AuthActions = () => import(/* webpackChunkName: "authActions" */ '@/views/partials/AuthActions.vue')
const AuthInvite = () => import(/* webpackChunkName: "authInvite" */ '@/views/partials/AuthInvite.vue')
const AuthAgreement = () => import(/* webpackChunkName: "authAgreement" */ '@/views/partials/AuthAgreement.vue')
const AuthLogin = () => import(/* webpackChunkName: "auth" */ '@/views/partials/AuthLogin.vue')
const AuthRegister = () => import(/* webpackChunkName: "auth" */ '@/views/partials/AuthRegister.vue')
const AuthVerify = () => import(/* webpackChunkName: "auth" */ '@/views/partials/AuthVerify.vue')
const AuthSelect = () => import(/* webpackChunkName: "auth" */ '@/views/partials/AuthSelect.vue')
const AuthDemo = () => import(/* webpackChunkName: "authDemo" */ '@/views/partials/AuthDemo.vue')

const PartialMatters = () => import(/* webpackChunkName: "matter" */ '@/views/partials/Matters.vue')
const PartialMatter = () => import(/* webpackChunkName: "matter" */ '@/views/partials/Matter.vue')

const CountNotesModal = () => import(/* webpackChunkName: "countNotes" */ '@/components/CountNotesModal.vue')
const UserAgreement = () => import(/* webpackChunkName: "agreement" */ '@/components/UserAgreement.vue')


const userGuard = async (to, from, next) => {
	const userStore = useUserStore()
	let user
	console.log('[userGuard]')
	try {
		user = await userStore.checkUser()
	} catch (error) {
		console.log('[userGuard].error', error)
		if (error?.code == 'auth/multi-factor-auth-required') {
			userStore.authStep = AuthStep.Verify
		}
		return next({ name: 'login', })
	}
console.log('[userGuard]', {to, user}, userStore.claims, )
	if (!user) return next({ name: 'login'} )

	if (userStore.claims?.metadata?.userLevel == 'demo') {
		if (to.name != 'calculator') {
			return next({name: 'calculator'})
		}
		return next()
	}

	if (!userStore.claims?.metadata?.mfaVerified) {
		console.log('[userGuard]', 'goVerify')
		return next({ name: 'verify' })
	}
	if (!userStore.claims?.metadata?.agreement) {
		console.log('[userGuard]', 'goAgreement', { agreementVersion, metadata: userStore.claims?.metadata})
		return next({ name: 'agreement' })
	}
	if (!userStore.claims?.tenantId) {
		console.log('[userGuard]', 'goInterstitial')

		return next({ name: 'select'})
	}

	return next()
}

const authGuard = async (to, from, next) => {
console.log('[authGuard]', { to, from, })
	if (to.name == 'login') return next()
	if (to.name == 'invite') return next()
	if (to.name == 'demo') return next()

	const userStore = useUserStore()

	let user
	try {
		user = await userStore.checkUser()
	} catch (error) {
		return next({ name: 'login' })
	}
console.log('[authGuard]', { user, claims: userStore.claims } )
	if (!user) {
		return next({ name: 'login' })
	}

	return next()
}

const checkoutGuard = async (to, from, next) => {
	const userStore = useUserStore()
	let user
	try {
		user = await userStore.checkUser()
	} catch (error) {
		// return next({ name: 'checkout' })
	}

console.log('[checkoutGuard]', { to,user })
	return next()
}

export const routes = [
	{
		name: 'auth',
		path: '/welcome',
		component: ViewAuth,
		// beforeEnter: authGuard,
		children: [
			{
				name: 'login',
				path: '',
				components: {
					Content: AuthLogin,
				},
			},
			{
				name: 'agreement',
				path: 'agreement',
				components: {
					Content: AuthAgreement,
				},
			},
			{
				name: 'verify',
				path: 'verify',
				components: {
					Content: AuthVerify,
				},
			},
			{
				name: 'select',
				path: 'select',
				components: {
					Content: AuthSelect,
				},
			},
			{
				name: 'register',
				path: 'register',
				components: {
					Content: AuthRegister,
				},
			},
			{
				name: 'invite',
				path: 'invite',
				components: {
					Content: AuthInvite,
				},
			},

			{
				name: 'interstitial',
				path: 'interstitial',
				components: {
					Content: PartialInterstitial,
				},
			},
			{
				name: 'demo',
				path: 'demo',
				components: {
					Content: AuthDemo,
				},
			},
		],
	},
	{
		name: 'public',
		path: '/checkout',
		component: ViewPublic,
		beforeEnter: checkoutGuard,
		children: [
			{
				name: 'checkout',
				path: '',
				components: {
					Content: PartialCheckout,
				},
			},
		],
	},
	{
		name: 'actions',
		path: '/actions',
		component: ViewAuth,
		children: [
			{
				name: 'action',
				path: '',
				components: {
					Content: AuthActions
				}
			}
		]
	},
	{
		name: 'main',
		path: '/',
		component: ViewMain,
		beforeEnter: userGuard,
		children: [
			{
				name: 'calculator',
				path: '',
				components: {
					Content: PartialCalculator,
				},
			},
			{
				name: 'countNotes',
				path: ':countId/notes',
				components: {
					Content: PartialCalculator,
					Modal: CountNotesModal,
				},
				meta: {
					modalVisible: true,
					modalTitle: `Count Notes`
				},
			},
			{
				name: 'matters',
				path: 'cases',
				components: {
					Content: PartialMatters,
				},
			},
			{
				name: 'matterNew',
				path: 'case/add',
				components: {
					Content: PartialMatter,
				},
			},
			{
				name: 'matter',
				path: 'case/:matterId/:edit?',
				components: {
					Content: PartialMatter,
				},
			},

			{
				name: 'matterCountNotes',
				path: ':countId/notes',
				components: {
					Content: PartialMatter,
					Modal: CountNotesModal,
				},
				meta: {
					modalVisible: true,
					modalTitle: `Count Notes`
				},
			},
			{
				name: 'me',
				path: 'me',
				components: {
					Content: PartialMe,
				},
			},
			{
				name: 'account',
				path: 'account',
				components: {
					Content: PartialAccount,
				},
			},
			{
				name: 'userAgreement',
				path: 'userAgreement',
				components: {
					Content: PartialCalculator,
					Modal: UserAgreement,
				},
				meta: {
					modalVisible: true,
					modalTitle: `Agreements`
				},
			},
		]
	}
]
